module.exports = __webpack_public_path__ + "img/图02-2.9762a16b.jpg";